<template>
    <v-autocomplete
        v-model="valueInner"
        :items="items"
        :item-text="itemText"
        :item-value="itemValue"
        :multiple="multiple"
        hide-details
        class="ScenarioSelect"
        @focusout="focusout"
        @input="input"
        :readonly="!isEditable"
        :placeholder="placeholder"
    >
        <template v-slot:selection="{ item, index }" v-if="multiple">
            <v-chip v-if="index === 0" small>
                <span>{{ mapValueToLabel[tooltip[0]] }}</span>
            </v-chip>
            <v-tooltip bottom v-if="index === 1">
                <template v-slot:activator="{ on }">
                    <span class="grey--text caption" v-on="on" style="cursor: default">
                        +{{ valueInner.length - 1 }}
                        <v-icon small>mdi-help-circle</v-icon>
                    </span>
                </template>
                <div v-for="item in tooltip" :key="item">{{ mapValueToLabel[item] }}</div>
            </v-tooltip>
        </template>
    </v-autocomplete>
</template>

<script>
import {ScenarioEventBus, ScenarioEventBusType} from "@/views/Scenario/scenario.eventbus";
import ScenarioService from "@/services/scenario.service";
import {mapState} from 'vuex'

export default {
    name: "ScenarioSelect",
    props: {
        value: {
            type: [String, Array]
        },
        itemText: {
            type: String,
            default: 'text'
        },
        itemValue: {
            type: String,
            default: 'value'
        },
        items: Array,
        multiple: Boolean,
        updateOnInput: Boolean,
        editable: {
            type: Boolean,
            default: null
        },
        placeholder: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            valueInner: null
        }
    },
    computed: {
        tooltip() {
            return this.multiple
                ? this.$lodash.orderBy(this.valueInner, item => item.includes('$') ? 'zzz' : item)
                : []
        },
        mapValueToLabel() {
            let mapValueToLabel = {}
            for (let item of this.items) {
                mapValueToLabel[item.value] = item.text
            }
            return this.$utils.limitStringLength(mapValueToLabel, 10)
        },
        ...mapState({
            stateEditable: () => ScenarioService.isEditable()
        }),
        isEditable() {
            if (typeof this.editable === 'boolean') {
                return this.editable
            }
            return this.stateEditable
        }
    },
    methods: {
        input() {
            if (this.updateOnInput && JSON.stringify(this.value) !== JSON.stringify(this.valueInner)) {
                this.$emit('input', this.multiple ? this.valueInner.join(';') : this.valueInner)
                this.$emit('save')
            }
        },
        focusout() {
            if (!this.updateOnInput && JSON.stringify(this.value) !== JSON.stringify(this.valueInner)) {
                this.$emit('input', this.multiple ? this.valueInner.join(';') : this.valueInner)
                this.$emit('save')
            }
        },
        handleValueChange() {
            let value = this.value ? this.value : ''
            if (this.multiple) {
                if (Array.isArray(value)) {
                    this.valueInner = value
                } else {
                    this.valueInner = value.split(';').filter(v => !!v)
                }
            } else {
                this.valueInner = Array.isArray(value) ? value[0] : value.split(';')[0]
            }
        },
        createNewItem() {
            ScenarioEventBus.$emit(ScenarioEventBusType.CREATE_INTENT, {
                resolve: result => {
                    console.log(result);
                }
            })
        },
        clear() {
            this.valueInner = this.multiple ? [] : ''
            this.$emit('input', '')
        }
    },
    watch: {
        value: {
            immediate: true,
            handler: function () {
                this.handleValueChange()
            }
        },
        multiple() {
            this.handleValueChange()
        }
    }
}
</script>

<style scoped lang="scss">
.ScenarioSelect {
    line-height: 32px;
    height: 32px;
    background: #FFFFFF;
    border-radius: 5px;
    border: 1px solid #D9D9D9;
    outline: none;
    font-size: 14px;
    padding: 6px 12px;
    margin: 0;
    display: flex;
    align-items: center;

    &.v-input--is-focused {
        border-color: #D9DBDE;
    }

    ::v-deep * {
        cursor: pointer;

        &:before, &:after {
            border: none !important;
        }

        .v-select__selections {
            white-space: nowrap;

            ::v-deep {
                cursor: pointer;
            }
        }
    }
}
</style>
